// extracted by mini-css-extract-plugin
export var orderSummary = "_oo-0";
export var showMoreLessButton = "_oo-1";